export const DEFAULT_PLACEHOLDER = "MM/DD/YYYY";
export const DEFAULT_PORTAL_ID = "calendar-portal";
